import React from 'react';

import { IconProps } from './types';

export const CertificateIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512.001 512.001"
    ref={forwardedRef}
    {...props}
  >
    <g>
      <g>
        <path
          d="M505.186,6.816C500.819,2.451,494.901,0,488.728,0L23.273,0.028C10.419,0.028,0,10.448,0,23.301v372.336
			c0,12.853,10.422,23.273,23.273,23.273h224.97v69.818c0,7.481,3.596,14.507,9.666,18.88c6.07,4.374,13.869,5.564,20.967,3.199
			l39.185-13.064l39.188,13.062c2.403,0.801,4.884,1.195,7.357,1.195c4.824,0,9.595-1.5,13.608-4.392
			c6.068-4.374,9.664-11.399,9.664-18.88v-69.818h100.849c12.854,0,23.273-10.42,23.273-23.273V23.273
			C512,17.099,509.549,11.18,505.186,6.816z M162.925,248.242l-46.545,0.028c-0.006,0-0.012,0-0.016,0
			c-12.848,0-23.263-10.409-23.273-23.259c-0.006-12.853,10.406-23.279,23.26-23.287l46.545-0.028c0.003,0,0.009,0,0.012,0
			c12.848,0,23.266,10.409,23.273,23.259C186.191,237.808,175.776,248.235,162.925,248.242z M387.148,358.914
			c-4.054,4.959-8.636,9.463-13.649,13.45c-2.833,2.254-5.797,4.352-8.893,6.254c-6.813,4.181-14.23,7.458-22.081,9.702
			c-0.397,0.113-0.791,0.231-1.192,0.338c-7.424,2.009-15.222,3.1-23.273,3.1c-8.051,0-15.849-1.091-23.273-3.1
			c-0.4-0.105-0.794-0.225-1.192-0.338c-7.852-2.244-15.27-5.52-22.081-9.702c-3.097-1.904-6.06-4-8.893-6.254
			c-5.011-3.987-9.595-8.491-13.649-13.45c-12.57-15.377-20.125-35.004-20.125-56.368c0-49.191,40.021-89.212,89.212-89.212
			s89.212,40.021,89.212,89.212C407.273,323.91,399.719,343.536,387.148,358.914z M395.64,139.636l-279.273,0.028
			c-12.854,0.002-23.273-10.418-23.276-23.271c0-12.853,10.418-23.273,23.27-23.274l279.273-0.028
			c12.854-0.002,23.276,10.417,23.276,23.27C418.913,129.213,408.491,139.635,395.64,139.636z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
));
CertificateIcon.displayName = 'CertificateIcon';

export default CertificateIcon;
